import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';

const Cta = ({ hideCta, children, ...props }) => (
  <S.Wrapper {...props}>{children}</S.Wrapper>
);

Cta.propTypes = {
  hideCta: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default Cta;
